






































import { Component, Vue } from "vue-property-decorator";
import { Popup } from "vant";
Vue.use(Popup);
@Component({
  components: {},
})
export default class Home extends Vue {
  public downloadShow = false;
  public url: any = {};
  public rows: any = {};
  public mobile = "";
  public show(url, data, mobile) {
    this.url = url;
    this.rows = data;
    this.mobile = mobile;
    this.downloadShow = true;
  }
  public downloadBox() {
    this.$fn.userRecord("2203", 2, "");
    if (this.mobile == "ios") {
      const arr: any = JSON.parse(this.url.enterprise_signs)
      const sar = Math.floor((Math.random() * arr.length));
      window.open(arr[sar], "_self");
    }
    if (this.mobile == "ad") {
      window.open(this.url.android_down_url, "_self");
    }
    return false;
    this.$fn.userRecord("2203", 2, "");
    window.open(this.url, "_self");
  }
  public downloadGame() {
    this.$fn.userRecord("2204", 2, "");
    if (this.mobile == "ios") {
      window.open(this.rows.ios_download_url, "_self");
    }
    if (this.mobile == "ad") {
      window.open(this.rows.down_url_android, "_self");
    }
  }
}
